"use client";

import { useEffect } from "react";
import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/navigation";

import FullScreenSpinner from "@/components/_ui/Spinner/FullScreenSpinner/FullScreenSpinner";

export default function SignInPage() {
    const { status } = useSession();
    const router = useRouter();

    useEffect(() => {
        switch (status) {
            case 'authenticated':
                router.push("/");
                return;
            case 'unauthenticated':
                signIn("vergo-auth", { callbackUrl: process.env.NEXT_PUBLIC_SITE_URL });
                return;
            default:
                return;
        }
    }, [status, router]);

    return <FullScreenSpinner />;
}
